/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {CalendarMonthOutlined, CalendarTodayOutlined} from "@mui/icons-material";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Formulario_Fechas = ({...props}) => {
    const {sCell} = useResponsive()

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 6, md: 6}} justifyContent={ sCell ? 'center' : 'flex-start'} >
                    <IngresoFecha Icono={CalendarTodayOutlined} nombre={'Fecha de Inicio'}
                                  dato={'fechaInicio'} {...props} ventana={false}
                                  requerido={'Las fechas son requeridas'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}} justifyContent={ sCell ? 'center' : 'flex-start'}>
                    <IngresoFecha Icono={CalendarMonthOutlined} nombre={'Fecha Final'} dato={'fechaFinal'} {...props}
                                  requerido={'Las fechas son requeridas'}  ventana={false}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Fechas